import Button from '@package/components/Button';
import Icon from '@package/components/Icon';
import PropTypes from 'prop-types';
import { shallowEqual, useSelector } from 'react-redux';
import { formatEventForModal } from './EventFormatter';
import { defineMessages, injectIntl } from 'react-intl';

/**
 * Componente de conteúdo padronizado para modais de eventos
 * Exibe detalhes do evento de forma consistente em diferentes contextos
 */
const messages = defineMessages({
  editEvent: {
    id: 'Edit event',
    defaultMessage: 'Edit event',
  },
  moreInfo: {
    id: 'More information',
    defaultMessage: 'More information',
  },
  moreInfoAria: {
    id: 'More information about event',
    defaultMessage: 'More information about event {title}',
  },
});

const EventModalContent = ({ event, lang = 'pt-br', intl }) => {
  // Verifica se o usuário está autenticado
  const token = useSelector((state) => state.userSession?.token, shallowEqual);
  const isAuthenticated = !!token;

  if (!event) return null;

  // Formata os dados do evento para exibição
  const eventData = formatEventForModal(event, {
    lang,
  });

  // URLs do evento
  const eventUrl = event.id || event['@id'] || '';
  const editUrl = eventUrl ? `${eventUrl}/edit` : '';
  const readMoreUrl = event.event_url || '';
  const hasUrl = !!readMoreUrl;

  return (
    <div className="event-modal-content">
      {eventData.theme && (
        <span className="event-theme-tag">{eventData.theme}</span>
      )}
      <h3>{eventData.title}</h3>
      {eventData.description && <p>{eventData.description}</p>}
      <div className="date">
        <Icon name="calendar_today" />
        {eventData.date}
      </div>
      {eventData.location && (
        <div className="location">
          <Icon name="location_on" />
          {eventData.location}
        </div>
      )}
      <div className="event-modal-actions">
        {isAuthenticated && editUrl && (
          <Button
            href={editUrl}
            label={intl.formatMessage(messages.editEvent)}
            xsmall
            link
          />
        )}
        {hasUrl && (
          <Button
            href={readMoreUrl}
            label={intl.formatMessage(messages.moreInfo)}
            aria-label={intl.formatMessage(messages.moreInfoAria, {
              title: eventData.title,
            })}
            openLinkInNewTab
            small
          />
        )}
      </div>
    </div>
  );
};
EventModalContent.propTypes = {
  event: PropTypes.shape({
    id: PropTypes.string,
    '@id': PropTypes.string,
    url: PropTypes.string,
    title: PropTypes.string,
    start: PropTypes.string,
    end: PropTypes.string,
    description: PropTypes.string,
    location: PropTypes.string,
    event_url: PropTypes.string,
  }),
  lang: PropTypes.string,
  intl: PropTypes.object.isRequired,
};
export default injectIntl(EventModalContent);
